import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { Routes, RouterModule } from '@angular/router';

import { IonicModule } from '@ionic/angular';

import { PickSlotPage } from './pick-slot.page';

import { ShopDetailSharedModule } from '../shared/shop-detail-shared.module';

import { DaysCalendarComponent } from './days-calendar/days-calendar.component';
import { ContactUsModalComponent } from './contact-us-modal/contact-us-modal.component';
import { SlotsComponent } from './slots/slots.component';

import { SharedModule } from '../../shared/shared.module';

import { PpTranslatePipe } from "../../shared/pipes/pp-translate.pipe"

import { AngularPhoneUtilsLibModule } from 'angular-phone-utils-lib';

const routes: Routes = [
  {
    path: '',
    component: PickSlotPage
  }
];

@NgModule({
  imports: [
    SharedModule,
    FormsModule,
    IonicModule,
    RouterModule.forChild(routes),
    ShopDetailSharedModule,
    AngularPhoneUtilsLibModule
  ],
  providers: [PpTranslatePipe], 
  declarations: [PickSlotPage, DaysCalendarComponent, SlotsComponent, ContactUsModalComponent]
})
export class PickSlotPageModule {}